"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant = require("../constant");
var _emojiScoring = _interopRequireDefault(require("./emojiScoring.proptypes"));
var _constant2 = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var EmojiContainer = _styledComponents.default.div.withConfig({
  displayName: "EmojiScoring__EmojiContainer",
  componentId: "sc-z7fvb1-0"
})(["display:inline-block;", ""], function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth && (0, _styledComponents.css)(["display:block;"]);
});
var EmojiList = _styledComponents.default.ul.withConfig({
  displayName: "EmojiScoring__EmojiList",
  componentId: "sc-z7fvb1-1"
})(["overflow:hidden;margin:0;padding:0;& > li:not(:last-child){margin-right:", ";}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.semi;
}, function (_ref3) {
  var fullWidth = _ref3.fullWidth;
  return fullWidth && (0, _styledComponents.css)(["display:flex;justify-content:space-between;overflow:visible;"]);
});
var EmojiItem = _styledComponents.default.li.withConfig({
  displayName: "EmojiScoring__EmojiItem",
  componentId: "sc-z7fvb1-2"
})(function (_ref4) {
  var isInactive = _ref4.isInactive;
  return "\n    cursor: pointer;\n    float: left;\n    list-style: none;\n\n    ".concat(isInactive ? " filter: grayscale(1);" : '', "\n  ");
});
var EmojiDescriptionContainer = _styledComponents.default.div.withConfig({
  displayName: "EmojiScoring__EmojiDescriptionContainer",
  componentId: "sc-z7fvb1-3"
})(["margin-top:", ";overflow:hidden;& p{font-size:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.medium;
}, function (_ref6) {
  var theme = _ref6.theme,
    fontSize = _ref6.fontSize;
  return theme.fontSize[fontSize];
});
var EmojiDescription = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "EmojiScoring__EmojiDescription",
  componentId: "sc-z7fvb1-4"
})(["", " ", ""], function (_ref7) {
  var left = _ref7.left;
  return left && (0, _styledComponents.css)(["float:left;"]);
}, function (_ref8) {
  var right = _ref8.right;
  return right && (0, _styledComponents.css)(["float:right;"]);
});
var EmojiScoring = function EmojiScoring(props) {
  var data = props.data,
    defaultValue = props.defaultValue,
    onEmojiClicked = props.onEmojiClicked,
    minText = props.minText,
    maxText = props.maxText,
    textColor = props.textColor,
    textSize = props.textSize,
    fullWidth = props.fullWidth,
    theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties,
    setActionName = props.setActionName;
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedEmoji = _useState2[0],
    setSelectedEmoji = _useState2[1];
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var onClickHandler = function onClickHandler(val, index) {
    setSelectedEmoji(val);
    if (setActionName) {
      setActionName("".concat(parseInt(index + 1, 10)));
    }
    if (onEmojiClicked) {
      onEmojiClicked(val);
    }
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(EmojiContainer, (0, _extends2.default)({
      id: "airasia-emoji-scoring",
      fullWidth: fullWidth
    }, customProperties), /*#__PURE__*/_react.default.createElement(EmojiList, {
      fullWidth: fullWidth
    }, data.map(function (d, index) {
      var EmojiSVG = selectedEmoji === d.value || !selectedEmoji ? _constant2.EMOJIS[d.emoji_active] : _constant2.EMOJIS[d.emoji_inactive];
      return /*#__PURE__*/_react.default.createElement(EmojiItem, {
        key: d.value,
        role: "button",
        tabIndex: tabIndex,
        onClick: function onClick() {
          return onClickHandler(d.value, index);
        },
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, function () {
            return onClickHandler(d.value);
          }, _constant.KEY_CODE.ENTER);
        },
        isInactive: selectedEmoji !== d.value && selectedEmoji
      }, /*#__PURE__*/_react.default.createElement(EmojiSVG, null));
    })), /*#__PURE__*/_react.default.createElement(EmojiDescriptionContainer, {
      fontSize: textSize
    }, /*#__PURE__*/_react.default.createElement(EmojiDescription, {
      left: true,
      color: textColor,
      theme: theme
    }, minText), /*#__PURE__*/_react.default.createElement(EmojiDescription, {
      right: true,
      color: textColor,
      theme: theme
    }, maxText)));
  };
  getMain.propTypes = _emojiScoring.default.PropTypes;
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
EmojiScoring.propTypes = _emojiScoring.default.PropTypes;
EmojiScoring.defaultProps = _emojiScoring.default.DefaultProps;
var _default = EmojiScoring;
exports.default = _default;